module.exports = __webpack_public_path__ + "media/views/builder/sites/assets/Alert-29b73fb46ab663e93eb9449c2f2b2a4a.svg";